import React from 'react';
import { packItems } from '../data/content';
export function WhatsInside() {
  return <section id="inside" className="w-full bg-white px-5 py-20 sm:py-28" data-id="element-193" data-mp="yvqz38dbhvo5">
      <div className="mx-auto max-w-4xl" data-id="element-194" data-mp="ytwkebsn2zsi">
        <h2 className="text-center text-[1.6rem] font-black leading-tight tracking-tight text-stone-900 sm:text-[2.2rem]" data-id="element-195" data-mp="kx117qiobryq">
          <span aria-hidden="true" data-id="element-196" data-mp="pu1aeaatlau2">📦 </span>What&apos;s Inside Every Lesson?
        </h2>
        <p className="mt-3 text-center text-sm text-stone-500" data-id="element-197" data-mp="b5dchxdi4p0y">
          Six lessons per volume, each built the same way so preparation stays
          simple.
        </p>

        <ul className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-198" data-mp="269vcyxwajp3">
          {packItems.map(item => <li key={item.title} className="rounded-2xl bg-stone-100 px-6 py-8 text-center" data-id="element-199" data-mp="74be1iresh01">
              <span className="text-2xl leading-none" aria-hidden="true" data-id="element-200" data-mp="3od85nz8wxt8k">
                {item.emoji}
              </span>
              <h3 className="mt-4 text-base font-bold text-stone-900" data-id="element-201" data-mp="3tazv8mm3539l">
                {item.title}
              </h3>
              <p className="mt-2 text-xs leading-relaxed text-stone-500" data-id="element-202" data-mp="3cscq17xeow55">
                {item.text}
              </p>
            </li>)}
        </ul>
      </div>
    </section>;
}